angular.module('am4')
.controller('orgCtrl', function(
    $scope,
    $rootScope,
    $state,
    $stateParams,
    subscriptions,
    ngDialog,
    user,
    subscriptionService,
    orgFacService,
    organizationData,
    imageService,
    contactService,
    errorService,
    Analytics,
    $translate,
    $filter,
    $q,
    organizationContact) {
    var that = this,
        subscriptionId = null;


    that.id = +$state.params.id;

    that.data = organizationData;
    that.dataLoaded = true;
    that.isAdmin = $rootScope.isAdmin;
    that.contact = organizationContact || {};

    that.subscribed = false;
    subscriptions.forEach(function(subscription) {
        if (subscription.organization_id === that.id) {
            that.subscribed = true;
            subscriptionId = subscription.id;
        }
    });

    that.subscribe = function() {
        that.subscribing = true;


        subscriptionService.createUserSubscription(user.user_id, {
            organization_id: that.id
        })
        .then(function success(data) {
            Analytics.trackEvent('organization', 'subscribe', that.id);

            that.subscribing = false;
            that.subscribed = true;
            subscriptionId = data[0].id;
        })
        .catch(function(e) {
            errorService.addError('SUBSCRIBE_ERROR', e);
        });
    };

    that.unsubscribe = function() {
        that.subscribing = true;

        subscriptionService.deleteUserSubscription(user.user_id, subscriptionId)
        .then(function success() {
            Analytics.trackEvent('organization', 'unsubscribe', that.id);

            that.subscribing = false;
            that.subscribed = false;
            subscriptionId = null;
        })
        .catch(function(e) {
            errorService.addError('UNSUBSCRIBE_ERROR', e);
        });
    };

    that.moveFacility = (facility, e) => {
        e.stopPropagation();
        e.preventDefault();

        $q.all([organizationData, orgFacService.getOrganizationsDictionary()])
        .then(([orgData, availableOrganizations]) => {
            ngDialog.open({
                template: require('../views/modal/moveFacility.html'),
                plain: true,
                controller: 'moveFacilityCtrl as moveFacilityCtrl',
                resolve: {
                    orgData: () => orgData,
                    facility: () => facility,
                    availableOrganizations: () => availableOrganizations
                }
            });
        });

    };

    that.deactivate = function() {
        if ($rootScope.userPermissions.indexOf('JHT_ORG_FAC_MANAGEMENT') !== -1 && that.data.is_active) {
            that.deleteLoading = true;

            orgFacService.getOrganizationsDictionary()
            .then(function(res) {
                ngDialog.open({
                    template: require('../views/modal/deactivateOrganization.html'),
                    plain: true,
                    controller: 'deactivateOrganizationCtrl as deactivateOrganizationCtrl',
                    resolve: {
                        availableOrganizations: function() {
                            return res;
                        },
                        orgData: function() {
                            return that.data;
                        }
                    }
                });
            })
            .finally(function() {
                that.deleteLoading = false;
            });
        }
    };

    // Not currently in use
    that.reactivate = function() {
        if ($rootScope.userPermissions.indexOf('JHT_ORG_FAC_MANAGEMENT') !== -1 && !that.data.is_active) {
            that.deactivating = true;

            orgFacService.reactivateOrganization(that.id)
            .then(function() {
                Analytics.trackEvent('organization', 'reactivate', that.id);

                that.deactivating = false;
                that.data.is_active = true;
            })
            .catch(function(e) {
                errorService.addError('REACTIVATE_ORGANIZATION_ERROR', e);
            });
        }
    };

    that.editName = function() {
        var editScope = $scope.$new();

        editScope.name = that.data.name;
        editScope.renameTranslation = 'RENAME_ORGANIZATION';

        ngDialog.openConfirm({
            template: require('../views/modal/rename.html'),
            plain: true,
            scope: editScope
        })
        .then(function renameSuccess(newName) {
            return orgFacService.updateOrganization(that.id, {
                name: newName
            })
            .then(function(res) {
                Analytics.trackEvent('organization', 'editName', that.id);

                that.data = res;
            })
            .catch(function(e) {
                errorService.addError('UPDATE_ORGANIZATION_ERROR', e);
            });
        });
    };

    that.getOrganizationContact = function() {
        return contactService.getOrganizationContact(that.id)
        .then(contact => {
            that.contact = contact;
        });
    };

    that.editOrganizationContact = function() {
        const editOrganizationContact = $scope.$new();

        editOrganizationContact.contact_email = that.contact.contact_email || '';
        editOrganizationContact.contact_phone_number = that.contact.contact_phone_number || '';

        ngDialog.openConfirm({
            template: require('../views/modal/editContact.html'),
            plain: true,
            scope: editOrganizationContact
        })
        .then(function(updated) {
            return contactService.setOrganizationContact(that.id, updated)
            .then(() => {
                return that.getOrganizationContact();
            })
            .catch(function(e) {
                errorService.addError('UPDATE_CONTACT_ERROR', e);
            });
        });
    };

    that.hasOrgAdminPerm = function() {
        return $rootScope.userPermissions.indexOf('ORG_ADMIN') > -1;
    };

    that.hasOrgContactPerm = function() {
        return $rootScope.userPermissions.indexOf('ORG_CONTACTS') > -1;
    };

    that.hasFacilityLink = function() {
        return $rootScope.userPermissions.indexOf('FACILITY_READ') > -1;
    };

    $scope.$watch(function() {
        return that.showInactive;
    }, function(showInactive) {
        Analytics.trackEvent('organization', showInactive ? 'showInactive' : 'showActive', that.id);

        that.facilitiesFilter = showInactive ? {} : { is_active: 1 };
    });
});



// WEBPACK FOOTER //
// ./src/app/controllers/orgCtrl.js